import $ from "jquery";
import { component } from "picoapp";

class Quiz {
  constructor(el, ctx) {
    this.el = el;
    this.ctx = ctx;
    this.init();
  }

  init() {
    const self = this;
    // quiz
    var btn1 = 0,
      btn2 = 0,
      btn3 = 0,
      btn4 = 0;
    $(".qs-header-btn-inner").click(function() {
      $(".quiz-section-header").hide(); //fadeOut('fast');
      $(".quiz-section-01").fadeIn();
    });
    $(".btn_back").click(function() {
      $(this)
        .closest(".quiz-section-qutans")
        .hide();
      $(this)
        .closest(".quiz-section-qutans")
        .parents()
        .prev()
        .children(".quiz-section-qutans, .quiz-section-header")
        .fadeIn();
    });
    $(".btn_back.last_back").click(function() {
      $(this)
        .closest(".finial-box")
        .hide();
      $(".quiz-section-04").fadeIn();
    });

    $(".quiz-btn-01").click(function() {
      $(".quiz-section-02").fadeIn();
      $(".quiz-section-01").hide();
      btn1 = $(this).attr("data-value");
    });
    $(".quiz-btn-02").click(function() {
      $(".quiz-section-03").fadeIn();
      $(".quiz-section-02").hide();
      btn2 = $(this).attr("data-value");
    });
    $(".quiz-btn-03").click(function() {
      $(".quiz-section-03").hide();
      $(".quiz-section-04").fadeIn();
      btn3 = $(this).attr("data-value");
    });
    $(".quiz-btn-04").click(function() {
      $(".quiz-section-04").hide();
      $(".quiz-section-05").fadeIn();
      $(".quiz-btn-05").hide();
      btn4 = $(this).attr("data-value");
      var av = btn1 + btn2 + btn3 + btn4;
      self.quiz_show(av);
      let results = [];
      results = [
        $(".chouse_box_1 .collection-list-count").html() +
          "-" +
          $(".chouse_box_1 .collection-list-heading a").html(),
        $(".chouse_box_2 .collection-list-count").html() +
          "-" +
          $(".chouse_box_2 .collection-list-heading a").html(),
        $(".chouse_box_3 .collection-list-count").html() +
          "-" +
          $(".chouse_box_3 .collection-list-heading a").html(),
        $(".chouse_box_4 .collection-list-count").html() +
          "-" +
          $(".chouse_box_4 .collection-list-heading a").html(),
        $(".chouse_box_5 .collection-list-count").html() +
          "-" +
          $(".chouse_box_5 .collection-list-heading a").html(),
      ].sort();
      const mainRecommended = results[0].split("-")[1];

      $(".quiz-section-05").attr("data-results", mainRecommended);

      $('.klaviyo-form-Xdynxw input[type="text"]')
        .focus()
        .val(mainRecommended)
        .blur();
    });

    window.addEventListener("klaviyoForms", function(e) {
      if (e.detail.type == "submit") {
        $(".quiz-btn-05").fadeIn();
      }
    });

    $(".quiz-btn-05").click(function() {
      $(".quiz-section-05").hide();
      $(".finial-box").fadeIn();
      //alert(av);
    });

    if (!$("body.product").hasClass("promo_banner--true")) {
      //location.reload();
    }
  }

  quiz_show(value) {
    console.log("Result: ", value);
    $(".chouse_box_1, .chouse_box_2, .chouse_box_3, .chouse_box_4").removeClass(
      "full_section"
    );
    $(
      ".chouse_box_1 .most_txt, .chouse_box_2 .most_txt, .chouse_box_3 .most_txt, .chouse_box_4 .most_txt"
    ).html("");
    var first = $(".recomment_section .first_rec").html();
    var second = $(".recomment_section .second_rec").html();
    var third = $(".recomment_section .third_rec").html();
    var fourth = $(".recomment_section .fourth_rec").html();
    var fifth = $(".recomment_section .fifth_rec").html();

    $(".chouse_box_1").removeClass("ch_4_section");
    $(".chouse_box_2").removeClass("ch_4_section");
    $(".chouse_box_3").removeClass("ch_4_section");
    //  $(".chouse_box_4").removeClass("ch_4_section");
    // $('.chouse_box_5').removeClass('ch_4_section');

    $(".chouse_box_1").removeClass("ch_5_section");
    $(".chouse_box_2").removeClass("ch_5_section");
    $(".chouse_box_3").removeClass("ch_5_section");
    //  $(".chouse_box_4").removeClass("ch_5_section");
    // $('.chouse_box_5').removeClass('ch_5_section');

    $(".chouse_box_1").removeClass("full_section");
    $(".chouse_box_2").removeClass("full_section");
    $(".chouse_box_3").removeClass("full_section");
    //  $(".chouse_box_4").removeClass("full_section");
    // $('.chouse_box_5').removeClass('full_section');

    if (value == "3211" || value == "3311" || value == "3411") {
      $(".chouse_box_1").css("order", "1");
      $(".chouse_box_1 .collection-list-count").html("01");
      $(".chouse_box_1 .no_of_txt").html(first); // single solid
      $(".chouse_box_2").css("order", "3");
      $(".chouse_box_2 .collection-list-count").html("03");
      $(".chouse_box_2 .no_of_txt").html(third); // modal
      $(".chouse_box_3").css("order", "2");
      $(".chouse_box_3 .collection-list-count").html("02");
      $(".chouse_box_3 .no_of_txt").html(second); // single chambray
      //  $(".chouse_box_4").css("order", "4");
      //  $(".chouse_box_4 .collection-list-count").html("04");
      //  $(".chouse_box_4 .no_of_txt").html(fourth); // double solid
      // $('.chouse_box_5').css('order', '5');
      // $('.chouse_box_5 .collection-list-count').html('05');
      // $('.chouse_box_5 .no_of_txt').html(fifth); // double chambray
      $(".chouse_box_1").addClass("full_section"); // first
      $(".chouse_box_1 .most_txt").html(first);

      //  $(".chouse_box_4").addClass("ch_4_section");
      // $('.chouse_box_5').addClass('ch_5_section');
    } else if (
      value == "1111" ||
      value == "1121" ||
      value == "1211" ||
      value == "1221" ||
      value == "1311" ||
      value == "1321" ||
      value == "1411" ||
      value == "1421" ||
      value == "2111" ||
      value == "2121" ||
      value == "2211" ||
      value == "2221" ||
      value == "2311" ||
      value == "2321" ||
      value == "2411" ||
      value == "2421" ||
      value == "3111" ||
      value == "3121" ||
      value == "3221"
    ) {
      $(".chouse_box_1").css("order", "1");
      $(".chouse_box_1 .collection-list-count").html("01");
      $(".chouse_box_1 .no_of_txt").html(first); // single solid
      $(".chouse_box_2").css("order", "2");
      $(".chouse_box_2 .collection-list-count").html("02");
      $(".chouse_box_2 .no_of_txt").html(second); // modal
      $(".chouse_box_3").css("order", "3");
      $(".chouse_box_3 .collection-list-count").html("03");
      $(".chouse_box_3 .no_of_txt").html(third); // single chambray
      //  $(".chouse_box_4").css("order", "4");
      //  $(".chouse_box_4 .collection-list-count").html("04");
      //  $(".chouse_box_4 .no_of_txt").html(fourth); // double solid
      // $('.chouse_box_5').css('order', '5');
      // $('.chouse_box_5 .collection-list-count').html('05');
      // $('.chouse_box_5 .no_of_txt').html(fifth); // double chambray
      $(".chouse_box_1").addClass("full_section"); // first
      $(".chouse_box_1 .most_txt").html(first);

      //  $(".chouse_box_4").addClass("ch_4_section");
      // $('.chouse_box_5').addClass('ch_5_section');
    } else if (value == "3321" || value == "3421") {
      $(".chouse_box_1").css("order", "1");
      $(".chouse_box_1 .collection-list-count").html("01");
      $(".chouse_box_1 .no_of_txt").html(first); // single solid
      $(".chouse_box_2").css("order", "3");
      $(".chouse_box_2 .collection-list-count").html("03");
      $(".chouse_box_2 .no_of_txt").html(third); // modal
      $(".chouse_box_3").css("order", "2");
      $(".chouse_box_3 .collection-list-count").html("02");
      $(".chouse_box_3 .no_of_txt").html(second); // single chambray
      //  $(".chouse_box_4").css("order", "2");
      //  $(".chouse_box_4 .collection-list-count").html("02");
      //  $(".chouse_box_4 .no_of_txt").html(second); // double solid
      // $('.chouse_box_5').css('order', '5');
      // $('.chouse_box_5 .collection-list-count').html('05');
      // $('.chouse_box_5 .no_of_txt').html(fifth); // double chambray
      $(".chouse_box_1").addClass("full_section"); // first
      $(".chouse_box_1 .most_txt").html(first);

      //  $(".chouse_box_2").addClass("ch_4_section");
      // $('.chouse_box_5').addClass('ch_5_section');
    } else if (
      value == "4111" ||
      value == "4121" ||
      value == "4211" ||
      value == "4221"
    ) {
      $(".chouse_box_1").css("order", "1");
      $(".chouse_box_1 .collection-list-count").html("01");
      $(".chouse_box_1 .no_of_txt").html(first); // single solid
      $(".chouse_box_2").css("order", "2");
      $(".chouse_box_2 .collection-list-count").html("02");
      $(".chouse_box_2 .no_of_txt").html(second); // modal
      $(".chouse_box_3").css("order", "3");
      $(".chouse_box_3 .collection-list-count").html("03");
      $(".chouse_box_3 .no_of_txt").html(third); // single chambray
      //  $(".chouse_box_4").css("order", "2");
      //  $(".chouse_box_4 .collection-list-count").html("02");
      //  $(".chouse_box_4 .no_of_txt").html(second); // double solid
      // $('.chouse_box_5').css('order', '5');
      // $('.chouse_box_5 .collection-list-count').html('05');
      // $('.chouse_box_5 .no_of_txt').html(fifth); // double chambray
      $(".chouse_box_1").addClass("full_section"); // first
      $(".chouse_box_1 .most_txt").html(first);

      //  $(".chouse_box_3").addClass("ch_4_section");
      // $('.chouse_box_5').addClass('ch_5_section');
    } else if (
      value == "1112" ||
      value == "1122" ||
      value == "1222" ||
      value == "2112" ||
      value == "2122" ||
      value == "2222"
    ) {
      $(".chouse_box_1").css("order", "3");
      $(".chouse_box_1 .collection-list-count").html("03");
      $(".chouse_box_1 .no_of_txt").html(third); // single solid
      $(".chouse_box_2").css("order", "1");
      $(".chouse_box_2 .collection-list-count").html("01");
      $(".chouse_box_2 .no_of_txt").html(first); // modal
      $(".chouse_box_3").css("order", "2");
      $(".chouse_box_3 .collection-list-count").html("02");
      $(".chouse_box_3 .no_of_txt").html(second); // single chambray
      //  $(".chouse_box_4").css("order", "4");
      //  $(".chouse_box_4 .collection-list-count").html("04");
      //  $(".chouse_box_4 .no_of_txt").html(fourth); // double solid
      // $('.chouse_box_5').css('order', '4');
      // $('.chouse_box_5 .collection-list-count').html('04');
      // $('.chouse_box_5 .no_of_txt').html(fourth); // double chambray
      $(".chouse_box_2").addClass("full_section"); // first
      $(".chouse_box_2 .most_txt").html(first);

      // $('.chouse_box_5').addClass('ch_4_section');
      //  $(".chouse_box_4").addClass("ch_4_section");
    } else if (
      value == "2312" ||
      value == "2412" ||
      value == "3212" ||
      value == "3222" ||
      value == "3312"
    ) {
      $(".chouse_box_1").css("order", "2");
      $(".chouse_box_1 .collection-list-count").html("02");
      $(".chouse_box_1 .no_of_txt").html(second); // single solid
      $(".chouse_box_2").css("order", "3");
      $(".chouse_box_2 .collection-list-count").html("03");
      $(".chouse_box_2 .no_of_txt").html(third); // modal
      $(".chouse_box_3").css("order", "1");
      $(".chouse_box_3 .collection-list-count").html("01");
      $(".chouse_box_3 .no_of_txt").html(first); // single chambray
      //  $(".chouse_box_4").css("order", "4");
      //  $(".chouse_box_4 .collection-list-count").html("04");
      //  $(".chouse_box_4 .no_of_txt").html(fourth); // double solid
      // $('.chouse_box_5').css('order', '4');
      // $('.chouse_box_5 .collection-list-count').html('04');
      // $('.chouse_box_5 .no_of_txt').html(fourth); // double chambray
      $(".chouse_box_3").addClass("full_section"); // first
      $(".chouse_box_3 .most_txt").html(first);

      // $('.chouse_box_5').addClass('ch_4_section');
      //  $(".chouse_box_4").addClass("ch_4_section");
    } else if (
      value == "4112" ||
      value == "4122" ||
      value == "4212" ||
      value == "4222"
    ) {
      // Hereeee
      $(".chouse_box_1").css("order", "3");
      $(".chouse_box_1 .collection-list-count").html("03");
      $(".chouse_box_1 .no_of_txt").html(third); // single solid
      $(".chouse_box_2").css("order", "2");
      $(".chouse_box_2 .collection-list-count").html("02");
      $(".chouse_box_2 .no_of_txt").html(second); // modal
      $(".chouse_box_3").css("order", "1");
      $(".chouse_box_3 .collection-list-count").html("01");
      $(".chouse_box_3 .no_of_txt").html(first); // single chambray
      //  $(".chouse_box_4").css("order", "4");
      //  $(".chouse_box_4 .collection-list-count").html("04");
      //  $(".chouse_box_4 .no_of_txt").html(fourth); // double solid
      // $('.chouse_box_5').css('order', '2');
      // $('.chouse_box_5 .collection-list-count').html('02');
      // $('.chouse_box_5 .no_of_txt').html(second); // double chambray
      $(".chouse_box_3").addClass("full_section"); // first
      $(".chouse_box_3 .most_txt").html(first);

      //  $(".chouse_box_1").addClass("ch_4_section");
      //  $(".chouse_box_4").addClass("ch_4_section");
    } else if (value == "3422") {
      $(".chouse_box_1").css("order", "2");
      $(".chouse_box_1 .collection-list-count").html("02");
      $(".chouse_box_1 .no_of_txt").html(second); // single solid
      $(".chouse_box_2").css("order", "3");
      $(".chouse_box_2 .collection-list-count").html("03");
      $(".chouse_box_2 .no_of_txt").html(third); // modal
      $(".chouse_box_3").css("order", "1");
      $(".chouse_box_3 .collection-list-count").html("01");
      $(".chouse_box_3 .no_of_txt").html(first); // single chambray
      //  $(".chouse_box_4").css("order", "2");
      //  $(".chouse_box_4 .collection-list-count").html("02");
      //  $(".chouse_box_4 .no_of_txt").html(second); // double solid
      // $('.chouse_box_5').css('order', '1');
      // $('.chouse_box_5 .collection-list-count').html('01');
      // $('.chouse_box_5 .no_of_txt').html(first); // double chambray
      $(".chouse_box_3").addClass("full_section"); // first
      $(".chouse_box_3 .most_txt").html(first);

      // $('.chouse_box_1').addClass('ch_4_section');
      //  $(".chouse_box_2").addClass("ch_4_section");
    } else if (value == "5412" || value == "5422") {
      $(".chouse_box_1").css("order", "2");
      $(".chouse_box_1 .collection-list-count").html("02");
      $(".chouse_box_1 .no_of_txt").html(second); // single solid
      $(".chouse_box_2").css("order", "3");
      $(".chouse_box_2 .collection-list-count").html("03");
      $(".chouse_box_2 .no_of_txt").html(third); // modal
      $(".chouse_box_3").css("order", "1");
      $(".chouse_box_3 .collection-list-count").html("01");
      $(".chouse_box_3 .no_of_txt").html(first); // single chambray
      //  $(".chouse_box_4").css("order", "1");
      //  $(".chouse_box_4 .collection-list-count").html("01");
      //  $(".chouse_box_4 .no_of_txt").html(first); // double solid
      // $('.chouse_box_5').css('order', '1');
      // $('.chouse_box_5 .collection-list-count').html('01');
      // $('.chouse_box_5 .no_of_txt').html(first); // double chambray
      $(".chouse_box_3").addClass("full_section"); // first
      $(".chouse_box_3 .most_txt").html(first);

      // $('.chouse_box_1').addClass('ch_4_section');
      //  $(".chouse_box_2").addClass("ch_4_section");
    } else if (value == "3322" || value == "3412") {
      $(".chouse_box_1").css("order", "2");
      $(".chouse_box_1 .collection-list-count").html("02");
      $(".chouse_box_1 .no_of_txt").html(second); // single solid
      $(".chouse_box_2").css("order", "3");
      $(".chouse_box_2 .collection-list-count").html("03");
      $(".chouse_box_2 .no_of_txt").html(third); // modal
      $(".chouse_box_3").css("order", "1");
      $(".chouse_box_3 .collection-list-count").html("01");
      $(".chouse_box_3 .no_of_txt").html(first); // single chambray
      //  $(".chouse_box_4").css("order", "3");
      //  $(".chouse_box_4 .collection-list-count").html("03");
      //  $(".chouse_box_4 .no_of_txt").html(third); // double solid
      // $('.chouse_box_5').css('order', '2');
      // $('.chouse_box_5 .collection-list-count').html('02');
      // $('.chouse_box_5 .no_of_txt').html(second); // double chambray
      $(".chouse_box_3").addClass("full_section"); // first
      $(".chouse_box_3 .most_txt").html(first);

      // $('.chouse_box_4').addClass('ch_4_section');
      //  $(".chouse_box_2").addClass("ch_4_section");
    } else if (
      value == "5111" ||
      value == "5121" ||
      value == "5211" ||
      value == "5221"
    ) {
      $(".chouse_box_1").css("order", "1");
      $(".chouse_box_1 .collection-list-count").html("01");
      $(".chouse_box_1 .no_of_txt").html(first); // single solid
      $(".chouse_box_2").css("order", "2");
      $(".chouse_box_2 .collection-list-count").html("02");
      $(".chouse_box_2 .no_of_txt").html(second); // modal
      $(".chouse_box_3").css("order", "3");
      $(".chouse_box_3 .collection-list-count").html("03");
      $(".chouse_box_3 .no_of_txt").html(third); // single chambray
      //  $(".chouse_box_4").css("order", "1");
      //  $(".chouse_box_4 .collection-list-count").html("01");
      //  $(".chouse_box_4 .no_of_txt").html(first); // double solid
      // $('.chouse_box_5').css('order', '4');
      // $('.chouse_box_5 .collection-list-count').html('04');
      // $('.chouse_box_5 .no_of_txt').html(fourth); // double chambray
      $(".chouse_box_1").addClass("full_section"); // first
      $(".chouse_box_1 .most_txt").html(first);

      // $('.chouse_box_5').addClass('ch_4_section');
      //  $(".chouse_box_3").addClass("ch_4_section");
    } else if (
      value == "4311" ||
      value == "4321" ||
      value == "4411" ||
      value == "4421" ||
      value == "5311" ||
      value == "5321" ||
      value == "5411" ||
      value == "5421"
    ) {
      $(".chouse_box_1").css("order", "1");
      $(".chouse_box_1 .collection-list-count").html("01");
      $(".chouse_box_1 .no_of_txt").html(first); // single solid
      $(".chouse_box_2").css("order", "2");
      $(".chouse_box_2 .collection-list-count").html("02");
      $(".chouse_box_2 .no_of_txt").html(second); // modal
      $(".chouse_box_3").css("order", "3");
      $(".chouse_box_3 .collection-list-count").html("03");
      $(".chouse_box_3 .no_of_txt").html(third); // single chambray
      //  $(".chouse_box_4").css("order", "1");
      //  $(".chouse_box_4 .collection-list-count").html("01");
      //  $(".chouse_box_4 .no_of_txt").html(first); // double solid
      // $('.chouse_box_5').css('order', '2');
      // $('.chouse_box_5 .collection-list-count').html('02');
      // $('.chouse_box_5 .no_of_txt').html(second); // double chambray
      $(".chouse_box_1").addClass("full_section"); // first
      $(".chouse_box_1 .most_txt").html(first);

      // $('.chouse_box_2').addClass('ch_4_section');
      //  $(".chouse_box_3").addClass("ch_4_section");
    } else if (
      value == "5112" ||
      value == "5122" ||
      value == "5212" ||
      value == "5222"
    ) {
      $(".chouse_box_1").css("order", "3");
      $(".chouse_box_1 .collection-list-count").html("03");
      $(".chouse_box_1 .no_of_txt").html(third); // single solid
      $(".chouse_box_2").css("order", "2");
      $(".chouse_box_2 .collection-list-count").html("02");
      $(".chouse_box_2 .no_of_txt").html(second); // modal
      $(".chouse_box_3").css("order", "1");
      $(".chouse_box_3 .collection-list-count").html("01");
      $(".chouse_box_3 .no_of_txt").html(first); // single chambray
      //  $(".chouse_box_4").css("order", "3");
      //  $(".chouse_box_4 .collection-list-count").html("03");
      //  $(".chouse_box_4 .no_of_txt").html(third); // double solid
      // $('.chouse_box_5').css('order', '1');
      // $('.chouse_box_5 .collection-list-count').html('01');
      // $('.chouse_box_5 .no_of_txt').html(first); // double chambray
      $(".chouse_box_3").addClass("full_section"); // first
      $(".chouse_box_3 .most_txt").html(first);

      // $('.chouse_box_4').addClass('ch_4_section');
      //  $(".chouse_box_1").addClass("ch_4_section");
    } else if (
      value == "4312" ||
      value == "4322" ||
      value == "4412" ||
      value == "4422" ||
      value == "5312" ||
      value == "5322"
    ) {
      $(".chouse_box_1").css("order", "3");
      $(".chouse_box_1 .collection-list-count").html("03");
      $(".chouse_box_1 .no_of_txt").html(third); // single solid
      $(".chouse_box_2").css("order", "2");
      $(".chouse_box_2 .collection-list-count").html("02");
      $(".chouse_box_2 .no_of_txt").html(second); // modal
      $(".chouse_box_3").css("order", "1");
      $(".chouse_box_3 .collection-list-count").html("01");
      $(".chouse_box_3 .no_of_txt").html(first); // single chambray
      //  $(".chouse_box_4").css("order", "1");
      //  $(".chouse_box_4 .collection-list-count").html("01");
      //  $(".chouse_box_4 .no_of_txt").html(first); // double solid
      // $('.chouse_box_5').css('order', '1');
      // $('.chouse_box_5 .collection-list-count').html('01');
      // $('.chouse_box_5 .no_of_txt').html(first); // double chambray
      $(".chouse_box_3").addClass("full_section"); // first
      $(".chouse_box_3 .most_txt").html(first);

      // $('.chouse_box_2').addClass('ch_4_section');
      //  $(".chouse_box_1").addClass("ch_4_section");
    } else if (
      value == "1212" ||
      value == "1312" ||
      value == "1322" ||
      value == "1412" ||
      value == "1422" ||
      value == "2212" ||
      value == "2322" ||
      value == "2422" ||
      value == "3112" ||
      value == "3122"
    ) {
      $(".chouse_box_1").css("order", "3");
      $(".chouse_box_1 .collection-list-count").html("03");
      $(".chouse_box_1 .no_of_txt").html(third); // single solid
      $(".chouse_box_2").css("order", "2");
      $(".chouse_box_2 .collection-list-count").html("02");
      $(".chouse_box_2 .no_of_txt").html(second); // modal
      $(".chouse_box_3").css("order", "1");
      $(".chouse_box_3 .collection-list-count").html("01");
      $(".chouse_box_3 .no_of_txt").html(first); // single chambray
      //  $(".chouse_box_4").css("order", "4");
      //  $(".chouse_box_4 .collection-list-count").html("04");
      //  $(".chouse_box_4 .no_of_txt").html(fourth); // double solid
      // $('.chouse_box_5').css('order', '4');
      // $('.chouse_box_5 .collection-list-count').html('04');
      // $('.chouse_box_5 .no_of_txt').html(fourth); // double chambray
      $(".chouse_box_3").addClass("full_section"); // first
      $(".chouse_box_3 .most_txt").html(first);

      // $('.chouse_box_5').addClass('ch_4_section');
      //  $(".chouse_box_4").addClass("ch_4_section");
    }
  }
}

// export default VideoCover;
export default component((node, ctx) => {
  new Quiz(node, ctx);
});
